import { BlockRenderer } from './blockrenderer';

export class HtmlPartials {

    public static base:string = `<!DOCTYPE html>
<html lang="sv">
    <head>
        <base href="/">
        <meta charset="UTF-8">
        <meta name="viewport" content="initial-scale=1.0, user-scalable=0, width=device-width, height=device-height"/>
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title><!--var:title--></title>
        <meta name="description" content="<!--var:description-->"/>

        <!--var:canonicals-->

        <!-- Google Tag Manager -->
        <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-THZ9XT4R');</script>
        <!-- End Google Tag Manager -->

        <script>window.compile_version_number='<!--var:version-->'</script>

        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
        <link rel="manifest" href="/site.webmanifest">
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5">
        <meta name="msapplication-TileColor" content="#da532c">
        <meta name="theme-color" content="#ffffff">

        <script>var exports = {};</script>
        <script src="static/jquery-3.4.1.min.js"></script>
        <script src="static/js.cookie.min.js" charset="UTF-8"></script>
        <script src="static/fuse.js"></script>

        <!--var:ogimage-->
        <meta property="og:title" name="og:title" content="<!--var:title-->"/>
        <meta property="og:description" name="og:description" content="<!--var:description-->"/>

        <link rel="stylesheet" href="https://use.typekit.net/ezf3kjn.css">
        <link rel="stylesheet" href="style.css?v=<!--var:version-->">

        <script>
            (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src='https://maps.'+c+'apis.com/maps/api/js?'+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                key: "AIzaSyC7aKBM3n-6pR8Po8tVi01lc9oImOQzx4g",
                v: "weekly",
                language: "sv"
            });
        </script>
    </head>
    <body class="<!--var:bodyclass-->" data-view="<!--var:viewid-->">
        <!-- Google Tag Manager (noscript) -->
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-THZ9XT4R"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <!-- End Google Tag Manager (noscript) -->
        <div class="map-container"></div>
        <div class="logo"><img src="static/travelhealth_blue_logo.svg" alt="" /></div>
        <!--var:menu-->
        <div class="content"<!--var:contentslug-->><!--var:content--></div>
        <div class="loader"><div class="spinner"><div class="lds-dual-ring"></div></div></div>
        <script src="bundle.js?v=<!--var:version-->"></script>
    </body>
</html>`;

    public static compile(vars:any) : string {
        let ogimage:any = vars.ogimage;
        if(ogimage?.url!=null) {
            ogimage = ogimage.url;
        } else {
            ogimage = null;
        }
        let ogimageurl:string = (ogimage!=null&&ogimage!="")?ogimage:"https://vaxiluskerna.se/std_share_vaxi.jpg";
        vars.ogimage = `<meta property="og:image" name="og:image" content="${ogimageurl}"/>`;
        vars.contentslug = vars.contentslug||"";
        if(vars.contentslug!="") {
            vars.contentslug = " data-slug='"+vars.contentslug+"'";
        }
        if(vars.canonicals==null) {
            vars.canonicals="";
        } else {
            let canonicalsStr = "";
            for(let m in vars.canonicals) {
                let c = vars.canonicals[m];
                canonicalsStr+='<link rel="canonical" href="'+c+'" />';
            }
            vars.canonicals = canonicalsStr;
        }

        return HtmlPartials.replaceVars(HtmlPartials.base, vars);
    }

    public static replaceVars(html:string, vars:any) : string {
        let r = html;
        let mregex = (/\<!--var:([^-->)]+)--\>/gim);
        let cRes = mregex.exec(html);
        while(cRes!=null) {
            let replaceText:string = vars[cRes[1]]||"";
            r = r.replace(cRes[0], replaceText);
            cRes = mregex.exec(html);
        }
        return r;
    }

    public static getVaxiArticle(data:any):string {
        let moreArticlesHtml = "";
        let tagsHtml = "";
        if(data.slug.indexOf("/")>0) {
            let backslug:string = (data.slug.split("/") as Array<string>).shift() as string;
            moreArticlesHtml = `<div class="more-articles"><div class='back-arrow'><svg alt="" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg></div><a href="/${backslug}">Fler artiklar</a></div>`;
        }
        if(data.variables?.tags?.value!=null&&data.variables?.tags?.value.length>0) {
            for(let m in data.variables.tags.value) {
                tagsHtml+=`<div class='article-tag'>${data.variables.tags.value[m]}</div>`;
            }
            tagsHtml=`<div class="article-tags">${tagsHtml}</div>`;
        }
        let privacyData:string = "<br>";
        if(data.slug=="privacy-policy") {
            privacyData = '<br><script id="CookieDeclaration" src="https://consent.cookiebot.com/1fcd5f04-ccb6-49d0-b6be-db5fcf4e80d7/cd.js" type="text/javascript" async></script>';
        }
        let html = `
            <div class="article-view" data-uid="${data.uid}">
                ${moreArticlesHtml}
                <div class="article-view-inner">
                    ${tagsHtml}
                    ${BlockRenderer.render(data?.variables?.content?.value)}
                    ${privacyData}
                </div>
            </div>
        `;
        html+=HtmlPartials.getVaxiBottomDisclaimer(data.slug)

        return html;
    }
    public static getVaxiArticleList(meta:any, list:any):string {
        let articlesHtml = "";
        list=list||{};
        let listArr:Array<any> = [];
        for(let m in list) {
            if(list[m]?.variables?.published?.value===true)
                listArr.push(list[m]);
        }
        listArr.sort((a:any, b:any):number => {
            if(a.variables?.date!=null&&b.variables?.date!=null) {
                let aTime:number = new Date(a.variables.date.value).getTime();
                let bTime:number = new Date(b.variables.date.value).getTime();
                if(aTime<bTime) return 1;
                if(aTime>bTime) return -1;
            }
            return 0;
        });
        let tagsCollected:Array<string> = [];
        for(let m in listArr) {
            let imageHtml="";
            if(listArr[m].variables?.featured_image?.value?.url) {
                let alt_tag:string="";
                if(listArr[m].variables.featured_image.value?.alt) {
                    alt_tag=` alt='${listArr[m].variables.featured_image.value.alt}'`;
                }
                imageHtml = `<img src='${listArr[m].variables.featured_image.value.url}'${alt_tag} />`;
            }
            let tagsHtml = "";
            for(let m2 in listArr[m].variables?.tags?.value) {
                let cTag:string = listArr[m].variables?.tags?.value[m2];
                if(!tagsCollected.includes(cTag)) tagsCollected.push(cTag);
                tagsHtml+=`<div class="article-list-item-tag">${cTag}</div>`;
            }
            articlesHtml+=`
                <div class='article-list-item' data-url='/${listArr[m].slug}' data-uid='${listArr[m].uid}' data-filters='${listArr[m].variables?.tags?.value?.join(",")||""}'>
                    <div class="article-list-item-content">
                        <div class='featured-image'>${imageHtml}</div>
                        <div class='article-intro'>
                            <div class="article-list-item-tags">${tagsHtml}</div>
                            <h2>${listArr[m].title}</h2>
                            <p>${listArr[m].variables.description.value}</p>
                            <a href='/${listArr[m].slug}' class='readmore'>Läs hela artikeln...</a>
                        </div>
                    </div>
                </div>
            `;
        }
        let tagsFilterHtml = ``;
        for(let m in tagsCollected) {
            let cTag:string = tagsCollected[m];
            tagsFilterHtml+=`<div class="tag-filter-item" data-filter="${cTag}">${cTag}</div>`;
        }
        let html = `
            <div class="articles-view" data-uid="articles-list" data-tagscollected="${tagsCollected.join(",")}">
                <div class="articles-view-inner">
                    ${BlockRenderer.render(meta?.variables?.content?.value)}
                    <div class='tag-filter'><div class='tag-filter-label'>Filtrera:</div><div class='tag-filter-tags'>${tagsFilterHtml}</div></div>
                    <div class='articles-list'>
                        ${articlesHtml}
                    </div>
                </div>
            </div>
        `;
        return html;
    }
    public static getVaxiMapView(sideviewData:any):string {
        let sideview = "";
        if(sideviewData!=null) {
            sideview = this.getVaxiReceptionSideview(sideviewData);
        }
        let searchHeadingLevel = 1;
        if(sideview!="") searchHeadingLevel = 2;
        let html = `
            <div class="map-view">
                <div class="map-search-container">
                    <h${searchHeadingLevel} class="searchHeading">Hitta vaccinatör nära dig</h${searchHeadingLevel}>
                    <p>Ska du ut och resa? Sök vaccinationsmottagning för vaccinering och vaccinationsrådgivning och läs mer om sjukdomar samt resevaccin.</p>
                </div>
                <div class="map-sideview-container">
                    <div class='map-sideview'>
                        <div class="map-sideview-inner">
                            ${sideview}
                        </div>
                        <div class="close-button">
                            <div class="icon">
                                <div class="chevron-left">&lt;</div>
                                <div class="chevron-right">&gt;</div>
                            </div>
                            <div class="label">
                                Karta
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        return html;
    }
    public static getVaxiReceptionSideview(data:any):string {
        let dataOut = {...data};
        //overridable: name/phone/web/address .. web and phone not presented in the list
        if(dataOut._name!=null&&dataOut._name!="") dataOut.name = dataOut._name; //override
        if(dataOut._phone!=null&&dataOut._phone!="") dataOut.phone = dataOut._phone; //override
        if(dataOut._web!=null&&dataOut._web!="") dataOut.web = dataOut._web; //override
        if(dataOut._address!=null&&dataOut._address!="") dataOut.address = dataOut._address; //override
        let place:string = ((dataOut.address||"").split(" ") as Array<string>).pop() as string;
        let html = `
            <div class="reception-details-top">
                <div class="ratio"></div>
                <img />
            </div>
            <div class="reception-details-menu">
                <div class="reception-details-menu-item website"><i class="material-symbols-sharp">public</i><span>Webbplats</span></div>
                <div class="reception-details-menu-item navigate"><i class="material-symbols-sharp">directions</i><span>Navigera</span></div>
                <div class="reception-details-menu-item phone"><i class="material-symbols-sharp">call</i><span>Ring</span></div>
            </div>
            <div class="reception-details-content">
                <h1><span class='small'>Vaccination, ${place}</span> 
                ${dataOut.name}</h1>
                <h3>${dataOut.address}</h3>
                <div class="opening-hours-container">
                    <h3>Öppettider</h3>
                    <div class="opening-hours"></div>
                </div>
                <div class="free-text">
                    <p>${BlockRenderer.render(dataOut?.freetext)}</p>
                </div>
            </div>
        `;
        return html;
    }
    public static getVaxiMenu(current_slug:string = ""):string {
        let html:string = `
            <div class="menu-view">
                <div class="menu-view-inner" role="navigation">
                    <a class="menu-item${(current_slug=="")?" active":""}" href="/map"><img src="static/icon_pin.svg" alt="">Hitta din vaccinatör</a>
                    <a class="menu-item${(current_slug=="infor-din-resa")?" active":""}" href="/infor-din-resa"><img src="static/icon_globe.svg" alt="">Inför din resa</a>
                    <div class="spacer"></div>
                    <a class="menu-item${(current_slug=="om-travelhealth")?" active":""} small" href="/om-travelhealth">Om travelhealth.se</a>
                    <a class="menu-item${(current_slug=="om-valneva")?" active":""} small" href="/om-valneva">Om Valneva</a>
                    ${HtmlPartials.getVaxiBottomDisclaimer(current_slug)}
                </div>
            </div>
        `;
        console.log(html); // Check the output in browser's console
        return html;
    }

    public static getVaxiBottomDisclaimer(current_slug:string = ""):string {
        let html:string = `
            <div class="bottom" role="banner">
                <div class="disclaimer">
                    <img src="static/valneva_logo.svg" alt="">
                    <p><b>Valneva Sweden AB • 105 21 Stockholm • Telefon växel: 08-121 01 500</b></p>
                    <p>Denna webbplats riktar sig till allmänheten i Sverige. För information kring reserådgivning eller rekommendationer om vaccinationer hänvisar vi till vaccinationsmottagning eller vårdcentral.<br>För biverkningsrapportering på någon av våra vacciner skriv till: <a href="mailto:valnevanordics@valneva.com">valnevanordics@valneva.com</a>.<br><span class='artnr'>SE-VAL-2400009-10-2024</span><br>© Copyright 2024.</p>
                    <div class="bottom-menu">
                        <div class="bottom-menu-item${(current_slug=="privacy-policy")?" active":""}"><a href="/privacy-policy">Privacy policy</a></div>
                        <div class="bottom-menu-item">|</div>
                        <div class="bottom-menu-item"><a href="javascript:if(window.Cookiebot!=null)window.Cookiebot.show();">Cookie-inställningar</a></div>
                    </div>
                </div>
            </div>
        `;

        return html;
    }

}